<app-service-settings-common
    [settingsKey]="store.settingsKey"
    [hideCustomCardNameInput]="true"
    [hideShareWithOtherServicesInput]="true"
    [title]="'service.settings.scheduler.header'"
>
    <ng-template #additionalContent>
        @if (store.visitsAllowed()) {
            <p-divider></p-divider>
            <div>
                <app-check-input
                    label="service.settings.scheduler.fields.useProcedureTime"
                    [pTooltip]="'service.settings.scheduler.message.useProcedureTime' | translate"
                    id="useProcedureTime"
                    [form]="form"
                ></app-check-input>
            </div>
        }
    </ng-template>
    <ng-template #footer>
        <app-action-buttons
            (primaryClickEvent)="save()"
            [secondaryButtonVisibility]="false"
        ></app-action-buttons>
    </ng-template>
</app-service-settings-common>
